import { CSSProperties, cloneElement } from 'react';
import styled from 'styled-components';

interface Props {
  icon: JSX.Element;
  size?: string;
  stroke?: string;
  fill?: string;
  className?: string;
  style?: CSSProperties;
  onClick?: () => void;
  title?: string;
}

/**
 * OA: This is an old wrapper made for previous versions of Streamline Icons. Streamline icons got updated
 * to use inline .svg's, so this wrapper is no longer needed as you can use the icons directly.
 * You can still use this wrapper if you feel like so, and nowadays it works with any inline svg.
 *
 * The wrapper <span> elements are here to mimic the old behavior of Streamline icons in order to not
 * break stuff.
 */

export function BouSvgIcon(props: Props) {
  return (
    <Root className={props.className} style={props.style}>
      <IconWrap>
        <StyledSvg
          svgElement={props.icon}
          onClick={props.onClick}
          height={props.size || '1.0em'}
          width={props.size || '1.0em'}
          stroke={props.stroke || 'currentColor'}
          fill={props.fill || undefined}
          title={props.title}
        />
      </IconWrap>
    </Root>
  );
}

const Root = styled.span``;

const IconWrap = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledSvg = styled(({ svgElement, ...props }) => cloneElement(svgElement, props))`
  path {
    stroke: ${props => props.stroke} !important;
    fill: ${props => props.fill} !important;
  }
`;
